export const CBRE_FLOW_NEW_WORK_REQUEST_SUCCESS_COUNT =
  'CBRE_FLOW_NEW_WORK_REQUEST_SUCCESS_COUNT';
